/**
 * Conversión robusta de valores de fecha a `Date`, SIN dependencias de Firebase.
 *
 * Es un módulo PURO a propósito: `accountState.js` (módulo puro, con test
 * unitario que lo importa directo) necesita convertir Timestamps sin arrastrar
 * `firebase/firestore` ni `../firebase` (que auto-inicializan Firebase al
 * importar y romperían el test). `ActivarCuenta.jsx` usa la misma función, así
 * los dos lectores del vencimiento del token NO pueden divergir nunca.
 *
 * Maneja, en orden:
 *   - falsy → null
 *   - Date (con guard de fecha inválida)
 *   - Timestamp de Firestore VIVO (método `.toDate()`)
 *   - Timestamp SERIALIZADO (pasó por JSON/cache/SDK admin): `{seconds,nanoseconds}`
 *     o `{_seconds,_nanoseconds}`  ← el caso que faltaba y mostraba "Vencida" antes de tiempo
 *   - number (epoch ms)
 *   - string (ISO u otra parseable)
 *
 * @param {any} value
 * @returns {Date|null}
 */
export function toJsDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  if (typeof value.toDate === "function") {
    try {
      const d = value.toDate();
      if (d instanceof Date && !isNaN(d.getTime())) return d;
    } catch (_) {
      // cae a los fallbacks de abajo
    }
  }
  // Timestamp serializado (sin método .toDate): {seconds,...} o {_seconds,...}
  const secs = value.seconds ?? value._seconds;
  if (typeof secs === "number") {
    const nanos = value.nanoseconds ?? value._nanoseconds ?? 0;
    const d = new Date(secs * 1000 + Math.floor(nanos / 1e6));
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === "number") {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === "string") {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}
